import React, { useState } from 'react';
import { FaFacebook, FaLink, FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa'; // Agregar más íconos
import Slider from 'react-slick'; // Importar el carrusel
import './App.css';
import fondo from './fondo.png'; // Import the local image

import { SpeedInsights } from '@vercel/speed-insights/react';

const data = [
  // {
  //   image: 'https://seeklogo.com/images/G/google-drive-logo-C66555C645-seeklogo.com.png',
  //   text: 'Descarga desde Drive',
  //   url:'https://drive.google.com/drive/folders/1WJ_aXoa1_Z2Vn3T-rnD3CwIOyxqTGAcL?usp=sharing',
  // },
  {
    image: 'https://seeklogo.com/images/H/huawei-appgallery-logo-A801F4AE11-seeklogo.com.png',
    text: 'Descarga desde la AppGallery',
    url: 'https://urldra.cloud.huawei.com/snND77eZYA',
  },
  {
    image: 'https://seeklogo.com/images/G/google-play-logo-C0F8C12322-seeklogo.com.png',
    text: 'Descarga desde la PlayStore',
    url: 'https://play.google.com/store/apps/details?id=com.aimeepineda.appzapoteco',
  },
  {
    image: 'https://seeklogo.com/images/A/apple-ios-app-store-logo-C39E303657-seeklogo.com.png',
    text: 'Próximamente',
    url: '',
  },
];
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', left: '-25px' }} // Personaliza el estilo de la flecha izquierda
      onClick={onClick}
    >

    </div>
  );
};

// Flecha personalizada para "Siguiente"
const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', right: '-25px' }} // Personaliza el estilo de la flecha derecha
      onClick={onClick}
    >

    </div>
  );
};

function App() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Solo un slide a la vez
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />, // Flecha izquierda personalizada
    nextArrow: <NextArrow />, // Flecha derecha personalizada
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };
  const handleButtonClick = (url) => {
    if (url) {
      window.open(url, '_blank'); // Abre el enlace en una nueva pestaña
    } else {
      // No hacer nada si no hay URL
      console.log("No hay URL disponible."); // Puedes eliminar esta línea si no quieres que haga nada
    }
  };

  return (
    <div className="container">
       <SpeedInsights />
      {/* Menú de Navegación */}
      <nav>
        <div className="menu-toggle" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        <ul className={isMenuOpen ? 'active' : ''}>
          <li><a href="#acerca" onClick={handleLinkClick}>¿Qué es?</a></li>
          <li><a href="#motivation" onClick={handleLinkClick}>Problemática</a></li>
          <li><a href="#features" onClick={handleLinkClick}>Características</a></li>
          <li><a href="#downloads" onClick={handleLinkClick}>Descargar</a></li>
          <li><a href="#video" onClick={handleLinkClick}>Demostración</a></li>
          <li><a href="#developer" onClick={handleLinkClick}>Contacto</a></li>
        </ul>
      </nav>

      {/* Imagen después del menú */}
      <div className="image-container">
<img 
  src={fondo} 
  alt="Fondo principal" 
  className="responsive-image"
/>
</div>

      {/* Encabezado pegado a la imagen */}
      <header id="home">
        <h1>Bizá'</h1>
      </header>
      <section id="acerca" className="acerca">
        <h2>¿Qué es?</h2>
        <p>Bizá' es una aplicación web y móvil desarrollada para promover el aprendizaje del zapoteco diidxazá, con el objetivo de preservar y revitalizar este idioma en riesgo de desaparición. La aplicación busca mitigar la pérdida de hablantes y contribuir activamente a la conservación de la riqueza cultural y lingüística del zapoteco diidxazá.</p>
      </section>
      <section id="motivation" className="motivation">
        <h2>Problemática a resolver</h2>
        <p>Bizá' nace a partir de la problemática identificada en torno a la disminución de hablantes del zapoteco diidxazá. A pesar de ser un patrimonio cultural y lingüístico de gran valor en México, esta variante está en riesgo de desaparición grado tres ya que solo el 18.47% de la población entre 5 y 18 años habla esta lengua, lo que indica que en aproximadamente 50 años, la transmisión intergeneracional del idioma podría ser prácticamente inexistente.</p>
      </section>

      {/* Características */}
      <section id="features" className="features">
        <h2>Características de Bizá'</h2>
        <div className="feature-image2">
          <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/muckups%20(Post%20de%20Instagram).png" alt="Características generales" />
        </div>
        <div className="features-container">

          <div className="feature-item">
            <div className="feature-image">
              <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/144.png" alt="Características generales" />
            </div>
            <div className="feature-text">
              <h3>Diccionario Trilingüe</h3>
              <p>Más de 2300 palabras con audios grabados por hablantes nativos.</p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-text">
              <h3>Traductor Bidireccional</h3>
              <p>Traducción bidireccional de zapoteco a otros idiomas</p>
            </div>
            <div className="feature-image">
              <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/145.png" alt="Característica 1" />
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-image">
              <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/146.png" alt="Característica 2" />
            </div>
            <div className="feature-text">
              <h3>Detector de Objetos y Texto</h3>
              <p>Identificación de objetos y reconocimiento de texto con inteligencia artificial a través de redes neuronales convolucionales.</p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-text">
              <h3>Sesiones de Aprendizaje</h3>
              <p> Niveles interactivos con videos, audios e imágenes basados en el modelo pedagógico de la teoría crítica.</p>
            </div>
            <div className="feature-image">
              <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/147.png" alt="Característica 3" />
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-image">
              <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/148.png" alt="Característica 4" />
            </div>
            <div className="feature-text">
              <h3>Evaluaciones Interactivas</h3>
              <p>Retroalimentación instantánea en preguntas abiertas y más.</p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-text">
              <h3>Juegos Educativos</h3>
              <p>Crucigramas, sopa de letras, memoramas, y más.</p>
            </div>
            <div className="feature-image">
              <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/149.png" alt="Característica 5" />
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-image">
              <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/150.png" alt="Característica 6" />
            </div>
            <div className="feature-text">
              <h3>Foro de Discusión</h3>
              <p>Crea, edita y elimina publicaciones, interactúa en los comentarios.</p>
            </div>
          </div>
        </div>
      </section>



      {/* Descargas */}
      <section id="downloads" className="downloads">
        <h2>Descarga Bizá'</h2>

        <div className="carousel-container">
          <Slider {...settings}>
            {data.map((item, index) => (
              <div key={index} className="carousel-item">

                <div className="button" onClick={() => handleButtonClick(item.url)}>
                  <img src={item.image} alt={item.text} className="carousel-image" />
                  <p className="carousel-text">{item.text}</p>
                </div>

              </div>
            ))}
          </Slider>
        </div>

      </section>
      <section className="web-app">
        <h2>Ver la Aplicación Web</h2>
        <p>Explora todas las funcionalidades y características de Bizá' en la versión web.</p>
        <a href="https://app-zapoteco.vercel.app" target="_blank" rel="noopener noreferrer">Ir a la Aplicación Web</a>
      </section>

      {/* Sección de Video */}
      <section id="video" className="video-section">
        <h2>Descubre más sobre Bizá'</h2>
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/rZKlcUaCNSM?si=SBiZefhhZfCyowjQ"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Video de Bizá'">
          </iframe>
        </div>
      </section>





      <section id="developer" className="developer">
        <h2>Acerca del Desarrollador</h2>
        <div className="developer-card">
          <img
            src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info//sin%20fondo%20blanco%20negrro.png"
            alt="Aimee Jahdai Pineda Nivón"
            className="developer-photo"
          />
          <h3>Aimee Jahdai Pineda Nivón</h3>
          <p>Ingeniera en Sistemas Computacionales con especialidad en Tecnologías De Software Emergente</p>
          <div className="developer-links">
            <a href="https://github.com/EmePin" target="_blank" rel="noopener noreferrer">
              <FaGithub size={32} />
            </a>
            <a href="https://linkedin.com/in/aimeepinedanivon" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={32} />
            </a>
            <a href="https://aimeelinks.vercel.app/" target="_blank" rel="noopener noreferrer">
              <FaLink size={32} />
            </a>
          </div>

        </div>
      </section>


      <br/>
      <br/>
      <div class="qr-container">
        <a href="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/qr%20brasil.png" download="codigo-qr.png">
          <button>Descargar Código QR</button>
        </a>
        <br></br>
        <img src="https://vlzorlnyxsdwknazbmmj.supabase.co/storage/v1/object/public/info/qr%20brasil.png" alt="Código QR" id="qrImage" />
      </div>


      {/* Footer simplificado */}
      <footer id="footer">
        <div className="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61565221121317" target="_blank" rel="noopener noreferrer">
            <FaFacebook size={24} color="#ffffff" />
          </a>
          <a href="https://www.instagram.com/biza_diidxaza/" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={24} color="#ffffff" />
          </a>
          <a href="https://www.linkedin.com/company/101986089" target="_blank" rel="noopener noreferrer">
            <FaLinkedin size={24} color="#ffffff" />
          </a>
        </div>
        <p>© Bizá'. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}

export default App;
